module.exports = __webpack_public_path__ + "assets/edit.fd78fd7fe19c97c4aaa59b663273a2d2.svg";


//////////////////
// WEBPACK FOOTER
// ./img/edit.svg
// module id = 934
// module chunks = 0